import { useMemo } from 'react'

import {
  E2E_EMPLOYEE_DETAILS_TAGS,
  E2E_EMPLOYEE_DETAILS_TAGS_ADD,
  E2E_EMPLOYEE_DETAILS_TAGS_REMOVE,
} from 'Constants/e2e'

import { employeeTaggingAdapter } from './employeeTaggingAdapter'
import type { EmployeeTagsRowProps } from './EmployeeTagsRow.types'
import { EntityTagsInner } from './EntityTagsInner'
import { EntityTagsProvider } from './EntityTagsProvider'
import type { Tag } from './tagging.types'

export const EmployeeTagsRow = (props: EmployeeTagsRowProps) => {
  const { employee, readOnly = false, refetch } = props
  const employeeId = employee.id

  const employeeTags = useMemo<Tag[]>(
    () =>
      (employee.tags ?? []).map(tag => ({
        color: tag.color,
        id: tag.id,
        name: tag.name,
      })),
    [employee.tags],
  )

  return (
    <EntityTagsProvider
      adapter={employeeTaggingAdapter}
      entityId={employeeId}
      entityTags={employeeTags}
      refetch={refetch}
    >
      <EntityTagsInner
        addDataE2e={E2E_EMPLOYEE_DETAILS_TAGS_ADD}
        className="EmployeeTagsRow"
        detailsDataE2e={E2E_EMPLOYEE_DETAILS_TAGS}
        entityId={employeeId}
        readOnly={readOnly}
        removeDataE2e={E2E_EMPLOYEE_DETAILS_TAGS_REMOVE}
        tags={employeeTags}
      />
    </EntityTagsProvider>
  )
}
